import { render, staticRenderFns } from "./Antonyms.vue?vue&type=template&id=229a1f32&lang=pug&"
import script from "./Antonyms.vue?vue&type=script&lang=js&"
export * from "./Antonyms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports